const UIDataBuilder = require('./ui_data_builder');

const CONST = {
    redSpanOpen: '<span class="od-baggage-persuasive-color odf-strong">',
    spanClosed: '</span>',
    positiveText: 'od-text-positive-prisma',
    positiveCobaltText: 'odf-text-positive',
    monoColor03: 'odf-text-mono-color-03',
    textNeutral500: 'odf-text-neutral-500',
    monoColor04: 'odf-text-mono-color-04',
    bold: 'odf-bold',
};

class UIDataBuilderMobile extends UIDataBuilder {
    constructor(constants = {}) {
        super(Odigeo._.merge({}, CONST, constants));
    }

    getColorByTheme() {
        return Odigeo.AB.isCobaltBoxVariant ? CONST.textNeutral500 : CONST.monoColor03;
    }

    getPositiveColorByTheme() {
        return Odigeo.AB.isCobaltBoxVariant ? CONST.positiveCobaltText : CONST.positiveText;
    }

    defaultData(keys) {
        const parentData = super.defaultData(keys);
        return Odigeo._.merge(parentData, {
            parent: {
                base: {
                    additionalInfo: {
                        classes: [this.CONST.bold, this.CONST.warningText].join(' '),
                    },
                },
                selected: {
                    additionalInfo: {
                        text: keys.cardMessageAdded,
                        classes: [this.CONST.bold, this.getPositiveColorByTheme()].join(' '),
                    },
                },
            },
            child: {
                base: {
                    title: {
                        text: keys.cardTitleAvailable,
                    },
                    footer: false,
                },
                selected: {
                    title: {
                        text: keys.cardTitleAvailable,
                    },
                    footer: false,
                },
            },
        });
    }

    noIncludedAndSelectable(keys) {
        const parentData = super.noIncludedAndSelectable(keys);

        const data = Odigeo._.merge(parentData, {
            child: {
                base: {
                    informativeMessage: {
                        messageTitle: keys.primeBenefitAvoidAirportFees
                            || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle, this.CONST.redSpanOpen,
                                this.CONST.spanClosed),
                        messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                    },
                },
                selected: {
                    informativeMessage: {
                        messageTitle: keys.primeBenefitAvoidAirportFees
                            || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle, this.CONST.redSpanOpen,
                                this.CONST.spanClosed),
                        messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    noIncludedAndNoSelectable(keys) {
        const parentData = super.noIncludedAndNoSelectable(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    title: {
                        text: keys.cardMessageNotIncluded,
                    },
                    additionalInfo: {
                        text: keys.cardSubtitleUnavailable,
                        classes: this.CONST.monoColor04,
                    },
                },
            },
            child: {
                hide: true,
                base: {
                    informativeMessage: false,
                },
                selected: {
                    informativeMessage: false,
                },
            },
        });

        return this.getData(keys, data);
    }

    allRowsIncludedAndExtra(keys, includedBaggageInformativeMessage) {
        const parentData = super.allRowsIncludedAndExtra(keys, includedBaggageInformativeMessage);

        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    icon: {
                        classes: this.CONST.selectedBagIcon,
                    },
                    additionalInfo: {
                        classes: [this.CONST.bold, this.CONST.infoText].join(' '),
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageTitle: keys.primeBenefitAvoidAirportFees
                            || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle, this.CONST.redSpanOpen,
                                this.CONST.spanClosed),
                        messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                    },
                },
                selected: {
                    informativeMessage: {
                        messageTitle: keys.primeBenefitAvoidAirportFees
                            || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle, this.CONST.redSpanOpen,
                                this.CONST.spanClosed),
                        messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    allRowsIncludedAndNoExtra(keys, includedBaggageInformativeMessage) {
        const parentData = super.allRowsIncludedAndNoExtra(keys, includedBaggageInformativeMessage);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    additionalInfo: {
                        classes: [this.CONST.bold, this.getPositiveColorByTheme()].join(' '),
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: false,
                    title: {
                        text: keys.cardTitleUnavailable,
                    },
                },
                selected: {
                    informativeMessage: false,
                    title: {
                        text: keys.cardTitleUnavailable,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    someRowsIncludedAndSelectable(keys, includedBaggageInformativeMessage) {
        const parentData = super.someRowsIncludedAndSelectable(keys, includedBaggageInformativeMessage);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    additionalInfo: {
                        text: keys.cardMessageSomeIncludedNegative,
                        classes: [this.CONST.bold, this.CONST.warningText].join(' '),
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: {
                        messageTitle: keys.primeBenefitAvoidAirportFees
                            || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle,
                                this.CONST.redSpanOpen, this.CONST.spanClosed),
                        messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                    },
                },
                selected: {
                    informativeMessage: {
                        messageTitle: keys.primeBenefitAvoidAirportFees
                            || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle,
                                this.CONST.redSpanOpen, this.CONST.spanClosed),
                        messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    someRowsIncludedAndNoSelectable(keys) {
        const parentData = super.someRowsIncludedAndNoSelectable(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    additionalInfo: {
                        classes: [this.CONST.bold, this.getPositiveColorByTheme()].join(' '),
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: false,
                    title: {
                        text: keys.cardTitleUnavailable,
                    },
                },
                selected: {
                    informativeMessage: false,
                    title: {
                        text: keys.cardTitleUnavailable,
                    },
                },
            },
        });

        return this.getData(keys, data);
    }

    trainStandalone(keys) {
        const parentData = super.trainStandalone(keys);
        const data = Odigeo._.merge(parentData, {
            parent: {
                base: {
                    additionalInfo: {
                        text: keys.trainStandaloneText,
                        classes: [this.CONST.bold, this.getPositiveColorByTheme()].join(' '),
                    },
                },
                selected: {
                    additionalInfo: {
                        text: keys.trainStandaloneText,
                        classes: [this.CONST.bold, this.getPositiveColorByTheme()].join(' '),
                    },
                },
            },
            child: {
                base: {
                    informativeMessage: false,
                },
                selected: {
                    informativeMessage: false,
                },
            },
        });

        return this.getData(keys, data);
    }

    promoBadge(keys, primeInfo = {}) {
        const {isPrimeView, isPrimeUser, discountAmount} = primeInfo;
        const primeTitleKey = discountAmount > 0 ? keys.discountSaveUpTo : keys.discountUpTo;
        const data = super.promoBadge(keys);

        Odigeo._.merge(data, {
            promoBadgeConfig: [
                {
                    name: 'merchandisingDiscount',
                    offerType: keys.promoBadgeSpecialOffer,
                    title: keys.promoBadgeMerchandisingDiscountTitle,
                    subtitle: null,
                    discountFigure: keys.promoBadgeDiscountFigure,
                    abTest: false,
                },
                {
                    name: 'xmas',
                    offerType: keys.promoBadgeSpecialOffer,
                    title: keys.promoBadgeXMasDiscountTitle,
                    subtitle: null,
                    discountFigure: keys.promoBadgeDiscountFigure,
                    abTest: !isPrimeView && Odigeo.AB.promotionMerchandisingXmas,
                },
                {
                    name: 'blackflyday',
                    offerType: keys.promoBadgeSpecialOffer,
                    title: keys.promoBadgeBlackFridayBlack,
                    subtitle: keys.promoBadgeBlackFridayFlyday,
                    discountFigure: keys.promoBadgeDiscountFigure,
                    abTest: !isPrimeView && Odigeo.AB.promotionMerchandisingBlackFriday,
                },
                {
                    name: 'primeAcquisition',
                    title: primeTitleKey,
                    subtitle: null,
                    abTest: Odigeo.AB.isBaggagePrimePriceDesktop && isPrimeView && !isPrimeUser,
                },
                {
                    name: 'primeRepeat',
                    title: primeTitleKey,
                    subtitle: null,
                    abTest: Odigeo.AB.isBaggagePrimePriceDesktop && isPrimeView && isPrimeUser,
                },
            ],
        });

        return data;
    }

    isVinFlight(keys, baggageInfo = {}) {
        const data = super.isVinFlight(keys, baggageInfo);

        Odigeo._.merge(data, {
            child: {
                base: {
                    informativeMessage: {
                        messageTitle: keys.cardMessagePopupVin,
                        messageAdditionalClasses: [this.CONST.largeText, this.CONST.strongText, this.CONST.infoText].join(' '),
                    },
                },
                selected: {
                    informativeMessage: {
                        messageTitle: keys.cardMessagePopupVin,
                        messageAdditionalClasses: [this.CONST.largeText, this.CONST.strongText, this.CONST.infoText].join(' '),
                    },
                },
            },
        });

        if (baggageInfo.noIncludedAndSelectable) {
            Odigeo._.merge(data, {
                parent: {
                    base: {
                        additionalInfo: {
                            text: baggageInfo.includedBaggageInformativeMessage,
                        },
                    },
                },
                child: {
                    base: {
                        informativeMessage: {
                            messageTitle: keys.primeBenefitAvoidAirportFees
                                || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle,
                                    this.CONST.redSpanOpen, this.CONST.spanClosed),
                            messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                        },
                    },
                    selected: {
                        informativeMessage: {
                            messageTitle: keys.primeBenefitAvoidAirportFees
                                || Odigeo.Utils.replaceCmsKeyArgs(keys.cardMessagePersuasiveTitle,
                                    this.CONST.redSpanOpen, this.CONST.spanClosed),
                            messageAdditionalClasses: [this.CONST.largeText, this.getColorByTheme()].join(' '),
                        },
                    },
                },
            });
        }

        return data;
    }

    primeAcquisition(keys, templates, primeInfo = {}) {
        const parentData = super.primeAcquisition(keys, templates, primeInfo);
        const {savedAmount = 0} = primeInfo;

        return Odigeo._.merge(parentData, {
            parent: {
                selected: {
                    discountInfo: {
                        classes: '',
                        text: templates.primeDiscountInfo({keys, savedAmount}),
                    },
                },
            },
        });
    }

    primeRepeat(keys, templates, primeInfo = {}) {
        const parentData = super.primeRepeat(keys, templates, primeInfo);
        const {savedAmount = 0} = primeInfo;

        return Odigeo._.merge(parentData, {
            parent: {
                selected: {
                    discountInfo: {
                        classes: '',
                        text: templates.primeDiscountInfo({keys, savedAmount}),
                    },
                },
            },
        });
    }
}

module.exports = UIDataBuilderMobile;
